import DemandOffersService from "../services/DemandOffersService";
import reduxStore from "../redux/store";
import {setSaveStatusError} from "../redux/actions";
import Tr from "../translations/Translations";

const isResponseValidWithStoredPasswordCheck = (
    response, passwordSetSuccessCallback, passwordSetErrorCallback, setErrors, skipShowError) => {

    if (response.success === true) {
        return true;
    } else {
        if (response.noValidPassword) {
            DemandOffersService.openContractorPasswordPopup(passwordSetSuccessCallback, passwordSetErrorCallback)
        } else if (!skipShowError) {
            if (response.errors && response.errors.length > 0)
                reduxStore.dispatch(setSaveStatusError(response.errors[0]));
            else
                reduxStore.dispatch(setSaveStatusError(Tr('bad_request_error')));
        }
        if (setErrors) {
            if(response.hasOwnProperty("offerErrors")) {
                setErrors(response.offerErrors);
            } else if (!response.noValidPassword) {
                setErrors(response.errors);
            }
        }
    }
    return false;
}

export default isResponseValidWithStoredPasswordCheck;